import { css, type Theme } from "@emotion/react";

export const wrapper = (theme: Theme) => css`
  width: 100%;
  max-width: 480px;
  text-align: center;
  padding: ${theme.ds5.spacing.padding.large};
`;
